import React, { useState, useEffect } from 'react';
import Loading from '../../Common/Loading';
import alert_A_bg from '../../Common/Images/ImagesForAlert/alert_A_bg.png';
import alert_bg from '../../Common/Images/ImagesForAlert/alert_Q_bg_small.png';
import ok_n from '../../Common/Images/ImagesForAlert/ok_n.png';
import ok_o from '../../Common/Images/ImagesForAlert/ok_o.png';
import yes_n from '../../Common/Images/ImagesForAlert/yes_n.png';
import yes_o from '../../Common/Images/ImagesForAlert/yes_o.png';
import no_n from '../../Common/Images/ImagesForAlert/no_n.png';
import no_o from '../../Common/Images/ImagesForAlert/no_o.png';
import EL_ProductsARD from './EL_ProductsARD';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface Product {
    ProdID: number;
    Country: string;
    Curriculum: string;
    ProdDesc: string;
    Subject: string;
    DICFileNames: string;
    Price: number;
    YearStart: number;
    YearEnd: number;
    ClassGradeType: string;
    ProductIncludes: string;
    Status: string;
}

const EL_ManageProducts: React.FC = () => {
    const [ardMode, setArdMode] = useState<'ADD' | 'EDIT' | 'DELETE'>('ADD');
    const [products, setProducts] = useState<Product[]>([]);
    const [countries, setCountries] = useState<string[]>(['-- All Countries --']);

    const [loading, setLoading] = useState<boolean>(false);
    const [filterCountry, setFilterCountry] = useState<string>('-- All Countries --');
    const [selectedProdID, setSelectedProdID] = useState<number | null>(null);
    type SortKey = keyof Product;

    const [sortConfig, setSortConfig] = useState<{
        key: SortKey;
        direction: 'asc' | 'desc';
    } | null>(null);

    const [alertMsg, setAlertMsg] = useState('');
    const [confirmConfig, setConfirmConfig] = useState<{ msg: string, onConfirm: () => void } | null>(null);
    const [showARD, setShowARD] = useState(false);
    const [isAddAction, setIsAddAction] = useState(false);

    const handleShowWarning = (msg: string) => setAlertMsg(msg);
    const handleShowConfirm = (msg: string, onConfirm: () => void) => {
        setConfirmConfig({ msg, onConfirm });
    };

    const handleConfirmYes = () => {
        if (confirmConfig) confirmConfig.onConfirm();
        setConfirmConfig(null);
    };

    useEffect(() => {
        const previousColor = document.body.style.backgroundColor;
        document.body.style.backgroundColor = 'white';

        fetchCountries();

        return () => {
            document.body.style.backgroundColor = previousColor;
        };
    }, []);

    useEffect(() => {
        handleSubmit();
    }, [filterCountry]);

    // const fetchCountries = async () => {
    //     try {
    //         const response = await fetch(`${API_BASE_URL}api/get_countries/`);
    //         if (response.ok) {
    //             const data = await response.json();
    //             const countryList = data.map((c: any) => c.major);
    //             setCountries(['-- All Countries --', ...countryList]);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching countries:", error);
    //     }
    // };
    const fetchCountries = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}api/get_countries/`);

            if (response.ok) {
                const data = await response.json();

                console.log("Countries Response:", data);

                setCountries([
                    '-- All Countries --',
                    ...(data.countries || [])
                ]);
            }
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };
    const handleSubmit = async () => {
        setLoading(true);
        setSelectedProdID(null);

        const params = new URLSearchParams();
        params.append('country', filterCountry);

        try {
            const response = await fetch(`${API_BASE_URL}api/manage-products/?${params.toString()}`);
            if (response.ok) {
                const data = await response.json();
                setProducts(data);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            handleShowWarning("Failed to load products.");
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (prod: Product) => {
        if (selectedProdID !== prod.ProdID) {
            setSelectedProdID(prod.ProdID);
        }
    };

    const handleDelete = () => {
        if (!selectedProdID) {
            handleShowWarning("Please select a Product to Modify / Delete");
            return;
        }
        setArdMode('DELETE');
        setShowARD(true);
    };

    const handleAdd = () => {
        setSelectedProdID(null);
        setArdMode('ADD');
        setShowARD(true);
    };

    const handleModify = () => {
        if (!selectedProdID) {
            handleShowWarning("Please select a Product to Modify / Delete");
            return;
        }
        setArdMode('EDIT');
        setShowARD(true);
    };

    const handleSort = (key: SortKey) => {
        setSortConfig((current) => {
            if (!current || current.key !== key) {
                return {
                    key,
                    direction: 'asc'
                };
            }

            if (current.direction === 'asc') {
                return {
                    key,
                    direction: 'desc'
                };
            }

            // Third click removes sorting
            return null;
        });
    };

    const renderDicFiles = (files: string) => {
        if (!files) return null;
        return files.split(',').map((f, i) => (
            <div key={i}>{f.trim()}</div>
        ));
    };

    const styles = {
        container: {
            fontFamily: 'Arial',
            fontSize: '10pt',
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column' as const,
            overflow: 'hidden'
        },
        topBar: {
            backgroundColor: '#99CCFF',
            padding: '5px 10px',
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            borderBottom: '1px solid #7F9DB9',
            flexShrink: 0
        },
        label: {
            fontSize: '12pt',
            marginRight: '5px',
            color: 'black'
        },
        select: {
            fontSize: '10pt',
            padding: '1px',
            marginRight: '30px'
        },
        btn: {
            backgroundColor: '#0099FF',
            color: 'white',
            fontWeight: 'bold' as const,
            border: '2px solid black',
            padding: '2px 15px',
            marginRight: '10px',
            width: '100px',
            cursor: 'pointer',
            fontSize: '10pt',
            textAlign: 'center' as const
        },
        gridContainer: {
            flex: 1,
            overflow: 'auto',
            border: '1px solid #7F9DB9',
            backgroundColor: 'white'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse' as const,
            fontSize: '9pt'
        },
        th: {
            backgroundColor: '#C7DDFD',
            color: '#003399',
            borderRight: '1px solid #7F9DB9',
            borderBottom: '1px solid #7F9DB9',
            padding: '8px',
            position: 'sticky' as const,
            top: 0,
            zIndex: 1,
            textAlign: 'left' as const,
            fontSize: '10pt',
            fontWeight: 'normal' as const,
            whiteSpace: 'nowrap' as const
        },
        td: {
            borderRight: '1px solid #D3D3D3',
            padding: '8px',
            fontSize: '10pt',
            verticalAlign: 'top' as const
        }
    };

    const sortedProducts = React.useMemo(() => {
        if (!sortConfig) {
            return products;
        }

        const sorted = [...products];

        sorted.sort((a, b) => {
            const valueA = a[sortConfig.key];
            const valueB = b[sortConfig.key];

            // Null / empty values
            if (
                valueA === null ||
                valueA === undefined ||
                valueA === ''
            ) {
                return 1;
            }

            if (
                valueB === null ||
                valueB === undefined ||
                valueB === ''
            ) {
                return -1;
            }

            // Numbers
            if (
                typeof valueA === 'number' &&
                typeof valueB === 'number'
            ) {
                return sortConfig.direction === 'asc'
                    ? valueA - valueB
                    : valueB - valueA;
            }

            // Strings
            const comparison = String(valueA)
                .trim()
                .localeCompare(
                    String(valueB).trim(),
                    undefined,
                    {
                        numeric: true,
                        sensitivity: 'base'
                    }
                );

            return sortConfig.direction === 'asc'
                ? comparison
                : -comparison;
        });

        return sorted;
    }, [products, sortConfig]);

    const renderSortableHeader = (
        label: React.ReactNode,
        key: SortKey
    ) => {
        const isActive = sortConfig?.key === key;

        return (
            <th
                style={{
                    ...styles.th,
                    cursor: 'pointer',
                    userSelect: 'none'
                }}
                onClick={() => handleSort(key)}
                title={`Sort by ${label}`}
            >
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}
                >
                    {label}

                    <span
                        style={{
                            fontSize: '10px',
                            color: isActive ? '#003399' : '#777',
                            fontWeight: 'bold'
                        }}
                    >
                        {isActive
                            ? sortConfig.direction === 'asc'
                                ? '▲'
                                : '▼'
                            : '↕'}
                    </span>
                </span>
            </th>
        );
    };
    return (
        <div style={styles.container}>
            <div style={styles.topBar}>
                <span style={styles.label}>Select Country:</span>
                <select
                    value={filterCountry}
                    onChange={(e) => setFilterCountry(e.target.value)}
                    style={{ ...styles.select, cursor: 'pointer' }}
                >
                    {countries.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <button style={{ display: 'none' }} onClick={handleSubmit}></button>

                <button style={styles.btn} onClick={handleAdd}>Add</button>
                <button style={styles.btn} onClick={handleModify}>Modify</button>
                <button style={styles.btn} onClick={handleDelete}>Delete</button>
                <button style={styles.btn} onClick={() => window.history.back()}>Go Back</button>
            </div>

            <div style={styles.gridContainer}>
                <table style={styles.table}>
                    {/* <thead>
                        <tr>
                            <th style={styles.th}>Prod ID</th>
                            <th style={styles.th}>Country</th>
                            <th style={styles.th}>Curriculum</th>
                            <th style={styles.th}>Description</th>
                            <th style={styles.th}>Subject</th>
                            <th style={styles.th}>Dic File Names</th>
                            <th style={styles.th}>Price</th>
                            <th style={styles.th}>Year<br />Start</th>
                            <th style={styles.th}>Year<br />End</th>
                            <th style={styles.th}>Class Grade<br />Type</th>
                            <th style={styles.th}>Product Includes</th>
                            <th style={styles.th}>Status</th>
                        </tr>
                    </thead> */}

                    <thead>
                        <tr>
                            {renderSortableHeader('Prod ID', 'ProdID')}
                            {renderSortableHeader('Country', 'Country')}
                            {renderSortableHeader('Curriculum', 'Curriculum')}
                            {renderSortableHeader('Description', 'ProdDesc')}
                            {renderSortableHeader('Subject', 'Subject')}
                            {renderSortableHeader('Dic File Names', 'DICFileNames')}
                            {renderSortableHeader('Price', 'Price')}
                            {renderSortableHeader(
                                <>Year<br />Start</>,
                                'YearStart'
                            )}
                            {renderSortableHeader(
                                <>Year<br />End</>,
                                'YearEnd'
                            )}
                            {renderSortableHeader(
                                <>Class Grade<br />Type</>,
                                'ClassGradeType'
                            )}
                            {renderSortableHeader(
                                'Product Includes',
                                'ProductIncludes'
                            )}
                            {renderSortableHeader('Status', 'Status')}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan={12} align="center"><Loading /></td></tr>
                        ) : sortedProducts.map((row, index) => {
                            const isSelected = selectedProdID === row.ProdID;
                            const bg = isSelected ? 'orange' : (index % 2 === 0 ? '#F4FAFF' : 'white');
                            const color = isSelected ? 'white' : 'black';

                            return (
                                <tr
                                    key={row.ProdID}
                                    onClick={() => handleRowClick(row)}
                                    style={{ backgroundColor: bg, cursor: 'pointer', color: color }}
                                >
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{row.ProdID}</td>
                                    <td style={styles.td}>{row.Country}</td>
                                    <td style={styles.td}>{row.Curriculum}</td>
                                    <td style={{ ...styles.td, width: '50px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.ProdDesc}</td>
                                    <td style={styles.td}>{row.Subject}</td>
                                    <td style={{ ...styles.td, width: '100px' }}>{renderDicFiles(row.DICFileNames)}</td>
                                    <td style={{ ...styles.td, textAlign: 'center', width: '20px' }}>{row.Price}</td>
                                    <td style={{ ...styles.td, textAlign: 'center', width: '20px' }}>{row.YearStart}</td>
                                    <td style={{ ...styles.td, textAlign: 'center', width: '20px' }}>{row.YearEnd}</td>
                                    <td style={{ ...styles.td, textAlign: 'center', width: '20px' }}>{row.ClassGradeType}</td>
                                    <td style={styles.td}>{row.ProductIncludes}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{row.Status}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {alertMsg && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 20000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '400px', height: '200px', backgroundImage: `url(${alert_A_bg})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%', position: 'relative', fontFamily: 'Tahoma, Arial, sans-serif', fontSize: '12px', color: 'black' }}>
                        <div style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontWeight: 'bold' }}>Warning</div>
                        <div style={{ position: 'absolute', top: '40px', left: '100px', right: '15px', bottom: '50px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                            <span style={{ fontWeight: 'normal', marginTop: '-25px', fontSize: '11pt' }}>{alertMsg}</span>
                        </div>
                        <div style={{ position: 'absolute', bottom: '10px', width: '100%', textAlign: 'center' }}>
                            <img src={ok_n} alt="OK" onClick={() => setAlertMsg('')} style={{ cursor: 'pointer' }} onMouseOver={(e) => e.currentTarget.src = ok_o} onMouseOut={(e) => e.currentTarget.src = ok_n} />
                        </div>
                    </div>
                </div>
            )}

            {confirmConfig && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 20000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '306px', height: '210px', backgroundImage: `url(${alert_bg})`, backgroundRepeat: 'no-repeat', position: 'relative', fontFamily: 'Tahoma', fontSize: '13px' }}>
                        <div style={{ position: 'absolute', top: '5px', left: '0', width: '100%', textAlign: 'center', color: 'white', fontWeight: 'bold', fontSize: '13px' }}>Confirmation</div>
                        <div style={{ position: 'absolute', top: '35px', left: '70px', right: '10px', height: '110px', display: 'flex', alignItems: 'center', color: '#525252', fontSize: '11pt' }}>
                            {confirmConfig?.msg}
                        </div>
                        <div style={{ position: 'absolute', bottom: '15px', width: '100%', textAlign: 'center' }}>
                            <img src={yes_n} alt="Yes" onClick={handleConfirmYes} style={{ cursor: 'pointer', margin: '-10px 15px' }} onMouseOver={(e) => e.currentTarget.src = yes_o} onMouseOut={(e) => e.currentTarget.src = yes_n} />
                            <img src={no_n} alt="No" onClick={() => setConfirmConfig(null)} style={{ cursor: 'pointer', margin: '-10px 15px' }} onMouseOver={(e) => e.currentTarget.src = no_o} onMouseOut={(e) => e.currentTarget.src = no_n} />
                        </div>
                    </div>
                </div>
            )}

            {showARD && (
                <EL_ProductsARD
                    prodId={selectedProdID ? selectedProdID.toString() : null}

                    mode={ardMode}
                    onClose={() => setShowARD(false)}
                    onSaveSuccess={handleSubmit}

                    showWarning={handleShowWarning}
                    showConfirm={handleShowConfirm}
                />
            )}
        </div>
    );
}

export default EL_ManageProducts;